import { injectable } from 'inversify';
import autobind from 'autobind-decorator';

@injectable()
export class PostcodeService {
    private geocoder: google.maps.Geocoder;

    constructor() {
        if (typeof google == 'object' && typeof google.maps == 'object') {
            this.geocoder = new google.maps.Geocoder();
        }
    }

    @autobind
    public search(search: string, fillContact: (address: Address[]) => void) {
        if (search.length < 3) return;
        if (this.geocoder != null) {
            this.geocoder.geocode({ 'address': search }, results => {
                if (results.length == 0) {
                    fillContact(null);
                } else {
                    const res: Address[] = [];
                    for (const item of results) {
                        let address = item.formatted_address;
                        let country: string;
                        let region: string;
                        let city: string;
                        let county: string;

                        for (const component of item.address_components) {
                            if (component.types.some(t => t == 'country')) {
                                country = component.long_name;
                            }
                            if (component.types.some(t => t == 'administrative_area_level_1')) {
                                region = component.long_name;
                            }
                            if (component.types.some(t => t == 'administrative_area_level_2')) {
                                county = component.long_name;
                            }
                            if (component.types.some(t => t == 'locality' || t == 'postal_town')) {
                                city = component.long_name;
                            }
                            if (city == null && component.types.some(t => t == 'postal_town')) {
                                city = component.long_name;
                            }
                        }
                        res.push({
							address1: address,
							address2: undefined,
                            town: city,
                            country: country,
							county: region || county,
                            postalCode: search,
                        });
                    }
                    fillContact(res);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/services/postcode.service.ts